import React from 'react';
import { Grid } from '@material-ui/core';

import css from './Layout.module.css';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import Footer from '../../components/Navigation/Footer/Footer';

const Layout = props => {

    return (
        <React.Fragment>
            <Grid container
                direction="column"
                justify="space-between">
                <Toolbar />
                <main className={css.Content}>
                    {props.children}
                </main>
                <Footer />
            </Grid>
        </React.Fragment>
    );
};

export default Layout;